import * as services from 'services/categories';

export const SET_ERROR = 'categories/SET_ERROR';
export const CLEAR_ERROR = 'categories/CLEAR_ERROR';
export const REQUEST_STARTED = 'categories/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'categories/REQUEST_SUCCESSFUL';
export const SET_CATEGORIES = 'categories/SET_CATEGORIES';
export const SET_CATEGORY = 'categories/SET_CATEGORY';
export const EDIT_CATEGORY = 'categories/EDIT_CATEGORY';
export const GET_CATEGORIES_FROM_SERVER =
  'categories/GET_CATEGORIES_FROM_SERVER';
export const DELETE_CATEGORY = 'categories/DELETE_CATEGORY';
export const ADD_CATEGORY = 'categories/ADD_CATEGORY';
export const SET_NEW_CATEGORY_ID = 'categories/SET_NEW_CATEGORY_ID';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setCategories = categories => ({
  type: SET_CATEGORIES,
  categories,
});

export const setCategory = category => ({
  type: SET_CATEGORY,
  category,
});

export const setNewCategoryId = newCategoryId => ({
  type: SET_NEW_CATEGORY_ID,
  newCategoryId,
});

export const getCategoriesFromServer = () => dispatch => {
  dispatch(requestStarted());
  services
    .getCategories()
    .then(categories => {
      dispatch(setCategories(categories));
      dispatch(requestCompleted());
    })
    .catch(() => {
      dispatch(setError('Error fetching categories'));
      dispatch(requestCompleted());
    });
};

export const addCategory = category => dispatch => {
  dispatch(requestStarted());
  services
    .addCategory(category)
    .then(({ success, id }) => {
      if (success) {
        dispatch(setNewCategoryId(id));
        dispatch(getCategoriesFromServer());
      } else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const editCategory = category => dispatch => {
  dispatch(requestStarted());
  services
    .editCategory(category)
    .then(({ success }) => {
      if (success) dispatch(getCategoriesFromServer());
      else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const deleteCategory = categoryId => dispatch => {
  dispatch(requestStarted());
  services
    .deleteCategory(categoryId)
    .then(({ success }) => {
      if (success) dispatch(getCategoriesFromServer());
      else dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};
